"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TextField_1 = __importDefault(require("../../../TextField"));
var form_1 = require("../../context/form");
var props_1 = require("../../context/props");
var NameField = function () {
    var _a = (0, form_1.useFormContext)(), name = _a.name, onChangeName = _a.onChangeName;
    var _b = (0, props_1.usePropsContext)(), translate = _b.translate, isLoading = _b.isLoading;
    return (react_1.default.createElement(TextField_1.default, { label: translate('feedbackModal.name'), value: name, onChange: onChangeName, name: "name", fullWidth: true, variant: "outlined", disabled: isLoading }));
};
exports.default = NameField;
